// Horizon scenery that matures with the child — same Bloom world, older atmosphere.

function House({ body = "#FFF4E3", roof = "#FF8B5E", className }) {
  return (
    <svg viewBox="0 0 70 62" className={className} aria-hidden>
      <rect x="10" y="26" width="50" height="34" rx="5" fill={body} />
      <path d="M6 30 L35 6 L64 30 Z" fill={roof} />
      <rect x="29" y="42" width="12" height="18" rx="3" fill="#A9746E" />
      <rect x="16" y="34" width="10" height="9" rx="2.5" fill="#BFE4F5" />
      <rect x="44" y="34" width="10" height="9" rx="2.5" fill="#BFE4F5" />
    </svg>
  );
}

function Mountain({ fill = "#B9C7E8", className }) {
  return (
    <svg viewBox="0 0 110 64" className={className} aria-hidden>
      <path d="M4 64 L44 8 Q55 -2 66 8 L106 64 Z" fill={fill} />
      <path d="M40 22 L55 4 L70 22 Q55 30 40 22 Z" fill="#FFFFFF" opacity="0.85" />
    </svg>
  );
}

function TrailFlags({ className }) {
  return (
    <svg viewBox="0 0 110 44" className={className} aria-hidden>
      <path d="M4 40 L4 6 M106 40 L106 6" stroke="#A9746E" strokeWidth="4" strokeLinecap="round" />
      <path d="M4 8 Q55 26 106 8" stroke="#8C6A54" strokeWidth="2" fill="none" />
      {[[18, 12], [40, 17], [62, 18], [84, 13]].map(([x, y], i) => (
        <path key={i} d={`M${x} ${y} l12 4 -12 6 z`} fill={["#FF7A45", "#FFD166", "#06D6A0", "#118AB2"][i]} />
      ))}
    </svg>
  );
}

function PineTree({ fill = "#3E9E6B", className }) {
  return (
    <svg viewBox="0 0 50 74" className={className} aria-hidden>
      <rect x="21" y="56" width="8" height="18" rx="3.5" fill="#8C5A3C" />
      <path d="M25 2 L44 30 L33 30 L48 54 L2 54 L17 30 L6 30 Z" fill={fill} />
    </svg>
  );
}

function RoundTree({ fill = "#57C690", className }) {
  return (
    <svg viewBox="0 0 54 70" className={className} aria-hidden>
      <rect x="23" y="48" width="8" height="22" rx="3.5" fill="#A9746E" />
      <circle cx="27" cy="28" r="24" fill={fill} />
    </svg>
  );
}

function TownBlock({ className }) {
  return (
    <svg viewBox="0 0 150 78" className={className} aria-hidden>
      <rect x="4" y="26" width="34" height="52" rx="4" fill="#CBDDE9" />
      <rect x="44" y="10" width="26" height="68" rx="4" fill="#F2E3CF" />
      <rect x="76" y="34" width="34" height="44" rx="4" fill="#D9E6D3" />
      {/* clock tower */}
      <rect x="118" y="16" width="22" height="62" rx="4" fill="#EAD9C4" />
      <circle cx="129" cy="30" r="8" fill="#FFFFFF" stroke="#A9746E" strokeWidth="2" />
      <path d="M129 30 L129 25 M129 30 L132 32" stroke="#2B2D42" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M116 18 L129 6 L142 18 Z" fill="#FF8B5E" />
      {[[10, 34], [24, 34], [10, 48], [24, 48], [50, 18], [50, 32], [50, 46], [82, 42], [96, 42], [82, 56], [96, 56]].map(([x, y], i) => (
        <rect key={i} x={x} y={y} width="8" height="9" rx="2" fill="#BFE4F5" />
      ))}
    </svg>
  );
}

function Academy({ className }) {
  return (
    <svg viewBox="0 0 190 86" className={className} aria-hidden>
      <rect x="10" y="34" width="170" height="52" rx="5" fill="#F4EBDD" />
      <path d="M4 38 L95 8 L186 38 Z" fill="#E0704F" />
      <rect x="88" y="-6" width="4" height="18" fill="#A9746E" />
      <path d="M92 -6 L110 -1 L92 4 Z" fill="#FFD166" />
      {[34, 74, 114, 154].map((x) => (
        <rect key={x} x={x} y="44" width="9" height="42" rx="3" fill="#E3D5C0" />
      ))}
      <path d="M83 86 L83 60 a12 12 0 0 1 24 0 L107 86 Z" fill="#7A5A44" />
      <rect x="24" y="48" width="12" height="12" rx="2.5" fill="#BFE4F5" />
      <rect x="154" y="48" width="12" height="12" rx="2.5" fill="#BFE4F5" />
    </svg>
  );
}

const SCENES = {
  1: null,
  2: (
    <>
      <div className="absolute left-[26%] bottom-[57%] sm:left-[30%] sm:bottom-[41%]">
        <House className="h-10 w-auto sm:h-16" />
      </div>
      <div className="absolute right-[20%] bottom-[58%] sm:right-[24%] sm:bottom-[42%]">
        <House body="#FDEDE4" roof="#FFB84D" className="h-8 w-auto sm:h-12" />
      </div>
    </>
  ),
  3: (
    <>
      <div className="absolute left-[14%] bottom-[58%] sm:left-[20%] sm:bottom-[42%]">
        <Mountain className="h-12 w-auto sm:h-20" />
      </div>
      <div className="absolute right-[16%] bottom-[59%] sm:right-[22%] sm:bottom-[43%]">
        <Mountain fill="#CBD5EE" className="h-9 w-auto sm:h-14" />
      </div>
      <div className="absolute left-1/2 bottom-[56%] hidden -translate-x-1/2 sm:block sm:bottom-[40%]">
        <TrailFlags className="h-9 w-auto" />
      </div>
    </>
  ),
  4: (
    <>
      <div className="absolute left-[17%] bottom-[57%] sm:left-[21%] sm:bottom-[41%]">
        <PineTree className="h-12 w-auto sm:h-20" />
      </div>
      <div className="absolute left-[27%] bottom-[58%] hidden sm:block sm:bottom-[42%]">
        <RoundTree fill="#4DB37E" className="h-14 w-auto" />
      </div>
      <div className="absolute right-[19%] bottom-[57%] sm:right-[23%] sm:bottom-[41%]">
        <PineTree fill="#357F58" className="h-10 w-auto sm:h-16" />
      </div>
      <div className="absolute right-[28%] bottom-[58%] hidden sm:block sm:bottom-[43%]">
        <PineTree fill="#4DB37E" className="h-10 w-auto" />
      </div>
    </>
  ),
  5: (
    <div className="absolute left-1/2 bottom-[56%] -translate-x-1/2 sm:bottom-[40%]">
      <TownBlock className="h-14 w-auto opacity-95 sm:h-24" />
    </div>
  ),
  6: (
    <div className="absolute left-1/2 bottom-[56%] -translate-x-1/2 sm:bottom-[40%]">
      <Academy className="h-16 w-auto sm:h-28" />
    </div>
  ),
};

export function Scenery({ year }) {
  const scene = SCENES[year];
  if (!scene) return null;
  return <div aria-hidden className="pointer-events-none absolute inset-0 z-[6]">{scene}</div>;
}
